import Api, { CleaningMission, User } from '@silbo/core';
import { startOfDay } from 'date-fns';
import { CLEANING_MISSION_INCLUDES } from '../get-open-cleaning-missions/get-open-cleaning-missions-query';

export const getMyFinishedCleaningMissionsTodayQuery = (user: User, today: Date) =>
  new Api.Query(CleaningMission)
    .equalTo('cleaner', user)
    .equalTo('status', 'done')
    .greaterThanOrEqualTo('updatedAt', startOfDay(today))
    .include(CLEANING_MISSION_INCLUDES)
    .descending('updatedAt')
    .limit(1000);
